import { z } from 'zod'

export const calculatePlanSchema = z
  .object({
    budget: z.number().min(0),
    allowSells: z.boolean(),
    orderType: z.enum(['market', 'limit']),
    limitOffsetPercent: z.number().min(0).max(100).optional(),
    // when true, the deployable money is the account's available cash (the `budget`
    // field is ignored). used by the bot to rebalance with the cash on hand.
    useAvailableCash: z.boolean().optional(),
    // when true (the default), leftover budget is topped up with whole lots that land
    // closer to target than not trading — including lots that overshoot the target
    // slightly. set false for strictly-under-target sizing: the auto-buy bot needs that,
    // since a top-up lot can end above target and its `allowBuyAboveTarget: false`
    // setting forbids exactly that.
    topUpLeftoverBudget: z.boolean().optional(),
  })
  .refine(
    (data) =>
      data.orderType !== 'limit' ||
      (data.limitOffsetPercent !== undefined && data.limitOffsetPercent >= 0),
    {
      message: 'limitOffsetPercent is required when orderType is limit',
      path: ['limitOffsetPercent'],
    }
  )

export type CalculatePlanDto = z.infer<typeof calculatePlanSchema>
